/* eslint react/prefer-stateless-function: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { Text, View } from 'react-native';
import { Button } from 'react-native-elements';

import AORTypes from '../../types';
import styles from '../../styles';
import { translate } from '../../locales/i18n';


class AppPreview extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.displayName = 'AppPreview';
  }

  render() {
    const { user, history, match: { params: { uuidApp } } } = this.props;

    return (
      <View
        style={styles.view.headless}
      >
        <Text
          style={{
            fontSize: 28,
            fontWeight: 'bold',
            alignSelf: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            paddingBottom: 52,
            paddingHorizontal: 20,
          }}
        >
          {translate('preview_unpublisherized_title')}
        </Text>
        <Text
          style={{
            alignSelf: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            paddingVertical: 32,
            paddingHorizontal: 20,
          }}
        >
          {translate('preview_unpublisherized_par1')}
        </Text>
        <Text
          style={{
            alignSelf: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            paddingHorizontal: 20,
          }}
        >
          {translate('preview_unpublisherized_par2')}
        </Text>

        <View>
          <Button
            title={translate('button_back')}
            containerStyle={{
              marginTop: 40,
              alignSelf: 'center',
            }}
            buttonStyle={styles.button.primary}
            disabledStyle={styles.button.primaryDisabled}
            titleStyle={styles.button.primaryTitle}
            disabledTitleStyle={styles.button.primaryTitleDisabled}
            onPress={() => {
              if (user && user.username) {
                history.push(`/ai-agent/${uuidApp}`);
              } else {
                history.push(`/signin/ai-agent/${uuidApp}`);
              }
            }}
          />
        </View>
      </View>
    );
  }
}

AppPreview.defaultProps = {
  user: null,
};

AppPreview.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
  user: AORTypes.AWS.Cognito.User,
  history: ReactRouterPropTypes.history.isRequired,
};

export default AppPreview;
